class SearchModal extends HTMLElement {
    constructor() {
      super();
      
      // this.init()
      // document.addEventListener('shopify:section:load', (event) => {
      //   if (event.target.closest('.shopify-section-header')) this.init()
      // })

      this.modal = this.querySelector('.search-modal');
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');
      this.input = this.querySelector('.search__input')
      this.searchField = this.summaryToggle.querySelector('.search-field__text')
      this.overlay = this.detailsContainer.querySelector('.search-modal__overlay')
      this.buttonClose = document.querySelector('.button-close--search')
      this.header = document.querySelector('.header')
  
      document.addEventListener(
        'keyup',
        (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
      );

      document.addEventListener('shopify:section:load', () => {
        setTimeout(document.documentElement.setAttribute('style', `--header-height: ${Math.floor(this.closest('.header').getBoundingClientRect().bottom)}px; --header-offset-height: ${Math.floor(this.closest('.header').getBoundingClientRect().bottom)}px;`), 1000)
      })
    
      if (this.searchField) {
        // this.summaryToggle.querySelector('.search-field__text').addEventListener('click', this.open.bind(this))
        this.summaryToggle.querySelector('.search-field__text').addEventListener('focus', this.open.bind(this))
      } else {
        this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this))
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', (event) => {
          this.reset(event)
          this.close()
        })
      }
      // document.querySelector('.search__button').addEventListener(
      //   'click',
      //   this.reset.bind(this)
      // );
      this.buttonClose.addEventListener(
        'click', (event) => {
          this.reset(event)
          this.close()
        }
      );
      this.header.addEventListener(
        'click', (event) => {
          if(this.modal.closest('.open') && !event.target.closest('.search')) {
            this.reset(event)
            this.close()
          }
        }
      );
      this.summaryToggle.setAttribute('role', 'button');
      // document.documentElement.setAttribute('style', `--header-offset-height: ${Math.floor(this.closest('.header').getBoundingClientRect().bottom)}px; --header-height: ${Math.floor(this.closest('.header').getBoundingClientRect().bottom)}px;`)
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open(event);
        this.open(event);
    }
  
    onBodyClick(event) {
      if (event.target.classList.contains('search-modal__overlay') || event.target.closest('.button-close--search')) this.close();
    }
  
    open() {
      if(this.modal.className.includes('open')) return
      document.documentElement.setAttribute('style', `--header-offset-height: ${Math.floor(this.closest('.header').getBoundingClientRect().bottom)}px; --header-height: ${Math.floor(this.closest('.header').getBoundingClientRect().bottom)}px;`)
      document.body.appendChild(this.modal)
      document.body.appendChild(this.overlay)
      if (this.searchField) {
        this.input.setAttribute('value', this.searchField.value)
        this.input.value = this.searchField.value
        // trapFocus(
        //   this.detailsContainer,
        //   this.searchField
        // );
        // this.input.addEventListener('focus', this.input.setSelectionRange(this.searchField.value.length, this.searchField.value.length))
      }
      else {
        trapFocus(
          this.detailsContainer,
          this.input
        );
      }
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      this.detailsContainer.setAttribute('open', true);
      this.overlay.classList.add('open')
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('search-modal--open');
      document.body.classList.add('hidden')
      this.modal.classList.add('open')
      document.dispatchEvent(new CustomEvent('searchmodal:open'));
    }
  
    close() {
      removeTrapFocus();
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('search-modal--open');
      document.dispatchEvent(new CustomEvent('searchmodal:close'));
      document.body.classList.remove('hidden')
      // if(document.querySelector('.search__button-text')) document.querySelector('.search__button-text').classList.add('visually-hidden')
      if (this.modal) this.modal.classList.remove('open')
      document.dispatchEvent(new CustomEvent('body:visible'));
      // if (this.searchField) this.searchField.value = ''
      // this.input.value = ''
      // document.body.removeChild(this.modal)
      if (this.modal) this.modal.remove()
      this.overlay = document.querySelector('.search-modal__overlay.open')
      // document.body.removeChild(this.overlay)
      if (this.overlay) this.overlay.remove()
    }
  
    reset(event) {
      event.preventDefault();
      if(this.querySelector('input[type="search"]') && this.querySelector('input[type="search"]').hasAttribute('value')) this.querySelector('input[type="search"]').value = '';
    }
  }
  
customElements.define('search-modal', SearchModal);